import { blue, orange, red } from "@/theme/colors";

export const DEFAULT_DAILY_STUDY_HOURS = 2;

/**
 * Preset daily study hour options for quick-select buttons.
 * Each preset includes value, color, labelKey, and recommended subLabel count.
 */
export const DAILY_BUTTON_PRESETS = [
  {
    value: 1,
    colorKey: blue[300],
    labelKey: "button_reexaminee",
    recommendedHour: 1,
  },
  {
    value: 2,
    colorKey: orange[300],
    labelKey: "button_recommended",
    recommendedHour: 2,
  },
  {
    value: 3,
    colorKey: red[300],
    labelKey: "button_do_your_best",
    recommendedHour: 3,
  },
] as const;
